var _rect, _path, _rect2, _circle, _circle2, _circle3, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStomach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 300,
    rx: 16,
    fill: "#fef3c7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M175 95 C165 95 150 110 145 135 C138 165 142 200 160 215 C178 230 210 225 225 210 C245 190 250 155 240 125 C235 110 220 95 210 95",
    stroke: "#d97706",
    strokeWidth: 3,
    fill: "#fffbeb"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 183,
    y: 70,
    width: 22,
    height: 30,
    rx: 7,
    fill: "#fffbeb",
    stroke: "#d97706",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 185,
    cy: 155,
    r: 4,
    fill: "#fbbf24",
    opacity: 0.35
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 205,
    cy: 170,
    r: 3,
    fill: "#fbbf24",
    opacity: 0.3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 195,
    cy: 185,
    r: 3.5,
    fill: "#fbbf24",
    opacity: 0.25
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 268,
    textAnchor: "middle",
    fontFamily: "'Segoe UI',Arial,sans-serif",
    fontSize: 18,
    fontWeight: 700,
    fill: "#92400e"
  }, "Ishal Tedavisi")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStomach);
export default __webpack_public_path__ + "static/media/stomach.caf20a7a075c4fa5009f86fbf30c7b9e.svg";
export { ForwardRef as ReactComponent };